module.exports = __webpack_public_path__ + "static/media/business-agility.29152016.jpg";